import PropTypes from 'prop-types';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import stylesModule from '../../../../summary-and-payment/styles.module.scss';

const ItemsInOrderTableWeight = ({ unitWeight }) => {
  const unitOfMeasure = useSelector(s => s.dealer?.unitOfMeasure) || '';

  return (
    <div>
      {unitWeight && (
        <p
          className={cx(
            'text-sm u-color--DarkGray mb-2',
            stylesModule['text-print-md']
          )}
        >
          {unitWeight} {unitOfMeasure}
        </p>
      )}
    </div>
  );
};

ItemsInOrderTableWeight.propTypes = {
  unitWeight: PropTypes.string
};

export default ItemsInOrderTableWeight;
